export var FlowPhase;
(function (FlowPhase) {
    FlowPhase["INIT"] = "init";
    FlowPhase["START"] = "start";
    FlowPhase["SIGNUP"] = "signup";
    FlowPhase["LOGIN"] = "login";
    FlowPhase["PASSWORD"] = "password";
    FlowPhase["SET_PASSWORD"] = "set_password";
    FlowPhase["RESET_PASSWORD"] = "reset_password";
    FlowPhase["PROVISIONAL"] = "provisional";
    FlowPhase["SOCIAL"] = "social";
    FlowPhase["CAPTCHA"] = "captcha";
    FlowPhase["VERIFY_EMAIL"] = "verify_email";
    FlowPhase["EMAIL_OTP"] = "email_otp";
    FlowPhase["SMS_OTP"] = "sms_otp";
    FlowPhase["TOTP"] = "totp";
    FlowPhase["MAGICLINK"] = "magiclink";
    FlowPhase["AGREEMENTS"] = "agreements";
    FlowPhase["PROFILE"] = "profile";
    FlowPhase["PASSKEY"] = "passkey";
    FlowPhase["CONSENT"] = "oauth_consent";
    FlowPhase["COMPLETE"] = "complete";
    FlowPhase["FLOW_RETURN"] = "return";
    FlowPhase["INVALID_AUTH_METHOD"] = "invalid_auth";
    FlowPhase["MISMATCH_EMAIL"] = "mismatch_email";
    FlowPhase["RESTART_STATE"] = "restart_state";
    FlowPhase["ERROR"] = "internal_error";
})(FlowPhase || (FlowPhase = {}));
